<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>申報年度</td>
                  <td colspan="3">
                    <select v-model="form.syear">
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>受理申報機關</td>
                  <td colspan="3">
                    <select
                      v-model="form.jobGovCode1"
                      style="min-width: 200px"
                      @change="JobGovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode2"
                      style="min-width: 200px"
                      @change="JobGovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode3"
                      style="min-width: 200px"
                      @change="JobGovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.jobGovCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>身分證統一編號</td>
                  <td>
                    <input type="text" v-model="form.idn" />
                  </td>
                  <td>姓名</td>
                  <td>
                    <input type="text" v-model="form.name" />
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="查詢"
                          @click="
                            () => {
                              this.form.currentpage = 1;
                              this.form.pagesize = 10;
                              this.doQuery();
                            }
                          "
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table
            width="100%"
            v-if="grid.gridDatas && grid.gridDatas.length > 0"
          >
            <tbody>
              <tr>
                <td>&nbsp;</td>
                <td align="right">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th>操作</th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('DTYPE', Sort);
                          }
                        "
                        >申報種類</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('NAME', Sort);
                          }
                        "
                        >姓名</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('IDN', Sort);
                          }
                        "
                        >身分證統一編號</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('GOV_CODE', Sort);
                          }
                        "
                        >服務機關</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('job_gov_code', Sort);
                          }
                        "
                        >受理申報機關</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('SDATE', Sort);
                          }
                        "
                        >申報基準日</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('DATETIME', Sort);
                          }
                        "
                        >上傳日期</u
                      >
                    </th>
                  </tr>
                </thead>
                <tbody
                  v-if="grid && grid.gridDatas && grid.gridDatas.length > 0"
                >
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="查看"
                        @click="btnDetail(data)"
                      />
                    </td>
                    <td>{{ data.dtype }}</td>
                    <td>{{ data.name }}</td>
                    <td>
                      <input
                        type="button"
                        class="btn"
                        :value="data.idn"
                        @click="btnA101Detail(data)"
                      />
                    </td>
                    <td>{{ data.goV_CODE_STR }}</td>
                    <td>{{ data.goV_NAME }}</td>
                    <td>{{ data.sdate }}</td>
                    <td>{{ data.datetimestr }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8" style="text-align: center">查無資料</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <PdisFooter />

    <DetailModal
      v-model="DetailModal.show"
      :title="DetailModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>申報人</td>
                <td>{{ DetailModal.PreData.name }}</td>
                <td>身分證統一編號</td>
                <td>{{ DetailModal.PreData.idn }}</td>
              </tr>
              <tr>
                <td>申報種類</td>
                <td>{{ DetailModal.PreData.dtype }}</td>
                <td>申報基準日</td>
                <td>{{ DetailModal.PreData.sdate }}</td>
              </tr>
              <tr>
                <td>上傳日期</td>
                <td>{{ DetailModal.PreData.datetime }}</td>
                <td>職稱</td>
                <td>{{ DetailModal.PreData.title }}</td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <input
                    type="button"
                    class="btn"
                    value="列印"
                    @click="btnDetailModalPrint()"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>

      <div class="information">
        <table width="100%">
          <tbody>
            <tr>
              <td>
                <ul>
                  <li class="TabbedPanelsTab">
                    <a
                      @click="DetailModal.MenuIndex = 0"
                      :style="{
                        color: DetailModal.MenuIndex == 0 ? '#F00' : '#000',
                      }"
                      >所得查調結果</a
                    >
                  </li>
                  <li class="TabbedPanelsTab">
                    <a
                      @click="DetailModal.MenuIndex = 1"
                      :style="{
                        color: DetailModal.MenuIndex == 1 ? '#F00' : '#000',
                      }"
                      >財產查調結果(房屋)</a
                    >
                  </li>
                  <li class="TabbedPanelsTab">
                    <a
                      @click="DetailModal.MenuIndex = 2"
                      :style="{
                        color: DetailModal.MenuIndex == 2 ? '#F00' : '#000',
                      }"
                      >財產查調結果(土地)</a
                    >
                  </li>
                  <li class="TabbedPanelsTab">
                    <a
                      @click="DetailModal.MenuIndex = 3"
                      :style="{
                        color: DetailModal.MenuIndex == 3 ? '#F00' : '#000',
                      }"
                      >財產查調結果(汽車)</a
                    >
                  </li>
                  <li class="TabbedPanelsTab">
                    <a
                      @click="DetailModal.MenuIndex = 4"
                      :style="{
                        color: DetailModal.MenuIndex == 4 ? '#F00' : '#000',
                      }"
                      >財產查調結果(營利事業所得稅結算申報之投資明細資料)</a
                    >
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 查詢結果開始-->
        <!-- 所得 -->
        <div v-show="DetailModal.MenuIndex === 0" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>所得人姓名</th>
                  <th>給付總額</th>
                  <th>扣繳<br />(可扣抵)稅額</th>
                  <th>所得<br />類別</th>
                  <th>所得<br />格式</th>
                  <th>所得來源</th>
                  <th>扣繳單位名稱</th>
                  <th>扣繳單位地址</th>
                  <th>
                    扣繳單位<br />
                    負責人姓名
                  </th>
                  <th>所得檔案編號</th>
                  <th>
                    所得<br />
                    註記
                  </th>
                  <th>異動<br />日期</th>
                </tr>
              </thead>
              <tbody
                v-if="
                  DetailModal.grid.incomes && DetailModal.grid.incomes.length
                "
              >
                <tr
                  v-for="(data, index) in DetailModal.grid.incomes"
                  :key="index"
                >
                  <td>{{ data.incmeR_NM }}</td>
                  <td>{{ data.paymenT_T_AMT }}</td>
                  <td>{{ data.wH_TAX }}</td>
                  <td>{{ data.incM_TP }}</td>
                  <td>{{ data.incM_FORMAT_CD }}</td>
                  <td>{{ data.incM_SOURCE }}</td>
                  <td>{{ data.wH_UNIT_NM }}</td>
                  <td>{{ data.wH_UNIT_ADDR }}</td>
                  <td>{{ data.wH_UNIT_RESP_NM }}</td>
                  <td>{{ data.incM_STR_ADDR }}</td>
                  <td>{{ data.incM_MK }}</td>
                  <td>{{ data.updatE_DATE }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="12" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
          <table width="100%">
            <tbody>
              <tr>
                <td height="83">
                  <span id="ctl00_ContentPlaceHolder1_Label2"
                    ><font color="#FF0000">*註 所得類別:</font></span
                  >
                  <br />
                  <span id="ctl00_ContentPlaceHolder1_Label1"
                    ><font color="#1E90FF"
                      >【1】營利所得 【2】執行業務報酬、稿費所得
                      【3】薪資所得【4】利息所得 【5】租賃、權利金所得
                      【7】財產交易所得 【8】競技競賽及機會中獎獎金所得
                      【9】退職所得</font
                    ></span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 房屋 -->
        <div v-show="DetailModal.MenuIndex === 1" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>姓名</th>
                  <th>財產別</th>
                  <th>現值金額</th>
                  <th>房屋座落</th>
                  <th>縣市別</th>
                  <th>異動年月</th>
                  <th>稅籍編號</th>
                  <th>房屋面積</th>
                  <th>房地持份比例</th>
                  <th>資料日期</th>
                  <th>土地標示</th>
                </tr>
              </thead>
              <tbody
                v-if="DetailModal.grid.builds && DetailModal.grid.builds.length"
              >
                <tr
                  v-for="(data, index) in DetailModal.grid.builds"
                  :key="index"
                >
                  <td>{{ data.nm }}</td>
                  <td>{{ data.type }}</td>
                  <td>{{ data.pR_VAL_AMT }}</td>
                  <td>{{ data.hoU_LOC }}</td>
                  <td>{{ data.hsN_TP }}</td>
                  <td>{{ data.updatE_DATE }}</td>
                  <td>{{ data.inQ_SEQ_NO }}</td>
                  <td>{{ data.hoU_AREA }}</td>
                  <td>{{ data.shR_RATIO }}</td>
                  <td>{{ data.replY_DATE }}</td>
                  <td>{{ data.lnD_MARK }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="11" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 土地 -->
        <div v-show="DetailModal.MenuIndex === 2" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>姓名</th>
                  <th>財產別</th>
                  <th>現值金額</th>
                  <th>地段</th>
                  <th>縣市別</th>
                  <th>異動日期</th>
                  <th>稅籍編號</th>
                  <th>房地<br />面積</th>
                  <th>房地持<br />份比例</th>
                  <th>資料日期</th>
                  <th>土地標示</th>
                  <th>地目</th>
                  <th>現值類別</th>
                </tr>
              </thead>
              <tbody
                v-if="DetailModal.grid.lands && DetailModal.grid.lands.length"
              >
                <tr
                  v-for="(data, index) in DetailModal.grid.lands"
                  :key="index"
                >
                  <td>{{ data.nm }}</td>
                  <td>{{ data.type }}</td>
                  <td>{{ data.pR_VAL_AMT }}</td>
                  <td>{{ data.addr }}</td>
                  <td>{{ data.hsN_TP }}</td>
                  <td>{{ data.updatE_DATE }}</td>
                  <td>{{ data.inQ_SEQ_NO }}</td>
                  <td>{{ data.hoU_AREA }}</td>
                  <td>{{ data.shR_RATIO }}</td>
                  <td>{{ data.replY_DATE }}</td>
                  <td>{{ data.lnD_MARK }}</td>
                  <td>{{ data.land }}</td>
                  <td>{{ data.pR_VAL_TP }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="13" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 汽車 -->
        <div v-show="DetailModal.MenuIndex === 3" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>姓名</th>
                  <th>財產別</th>
                  <th>地址</th>
                  <th>縣市別</th>
                  <th>車型車牌</th>
                  <th>汽缸容量</th>
                  <th>資料日期</th>
                  <th>廠牌</th>
                </tr>
              </thead>
              <tbody
                v-if="
                  DetailModal.grid.vehicles && DetailModal.grid.vehicles.length
                "
              >
                <tr
                  v-for="(data, index) in DetailModal.grid.vehicles"
                  :key="index"
                >
                  <td>{{ data.nm }}</td>
                  <td>{{ data.type }}</td>
                  <td>{{ data.hoU_LOC }}</td>
                  <td>{{ data.hsN_TP }}</td>
                  <td>{{ data.proP_LOSN }}</td>
                  <td>{{ data.shR_RATIO }}</td>
                  <td>{{ data.replY_DATE }}</td>
                  <td>{{ data.lnD_MARK }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="8" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 營利事業所得稅結算申報之投資明細資料 -->
        <div v-show="DetailModal.MenuIndex === 4" class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>姓名</th>
                  <th>財產別</th>
                  <th>現值金額</th>
                  <th>公司名稱</th>
                  <th>縣市別</th>
                  <th>被投資<br />公司統編</th>
                  <th>資料日期</th>
                  <th>檔案編號</th>
                </tr>
              </thead>
              <tbody
                v-if="
                  DetailModal.grid.investments &&
                  DetailModal.grid.investments.length
                "
              >
                <tr
                  v-for="(data, index) in DetailModal.grid.investments"
                  :key="index"
                >
                  <td>{{ data.nm }}</td>
                  <td>{{ data.type }}</td>
                  <td>{{ data.pR_VAL_AMT }}</td>
                  <td>{{ data.hoU_LOC }}</td>
                  <td>{{ data.hsN_TP }}</td>
                  <td>{{ data.proP_LOSN }}</td>
                  <td>{{ data.replY_DATE }}</td>
                  <td>{{ data.incomE_LOSN }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="8" style="text-align: center">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果結束-->
        <div>
          <tr>
            <td height="83">
              <span id="ctl00_ContentPlaceHolder1_Label2"
                ><font color="#FF0000"
                  >*※本財稅資料僅供公職人員財產申報實質審查使用，不得轉為他用或供非財產申報業務相關人員閱覽、使用。</font
                ></span
              >
              <br />
            </td>
          </tr>
        </div>
      </div>
    </DetailModal>

    <A101DetailModal
      v-model="A101DetailModal.show"
      :title="A101DetailModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>服務機關</td>
                <td colspan="3">
                  <select
                    v-model="A101DetailModal.form.jobGovCode1"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .jobGovCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.jobGovCode2"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .jobGovCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.jobGovCode3"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .jobGovCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.jobGovCode4"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .jobGovCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>受理申報機關</td>
                <td colspan="3">
                  <select
                    v-model="A101DetailModal.form.govCode1"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .govCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.govCode2"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .govCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.govCode3"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .govCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="A101DetailModal.form.govCode4"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .govCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>身分證統一編號/居留證號</td>
                <td>
                  <input
                    type="text"
                    maxlength="20"
                    v-model="A101DetailModal.form.idn"
                    disabled
                  />
                </td>
                <td>姓名</td>
                <td>
                  <input
                    type="text"
                    v-model="A101DetailModal.form.name"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>生日</td>
                <td colspan="3">
                  <DatePicker
                    v-model="A101DetailModal.form.birthday"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>單位及職稱</td>
                <td>
                  <input
                    type="text"
                    v-model="A101DetailModal.form.title"
                    disabled
                  />
                </td>
                <td>階級</td>
                <td>
                  <select v-model="A101DetailModal.form.rank" disabled>
                    <option value="">無</option>
                    <option value="1">上將</option>
                    <option value="2">中將</option>
                    <option value="3">少將</option>
                    <option value="4">上校</option>
                    <option value="5">中校</option>
                    <option value="6">少校</option>
                    <option value="7">上尉</option>
                    <option value="8">中尉</option>
                    <option value="9">少尉</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>聯絡電話</td>
                <td>
                  <input
                    type="text"
                    v-model="A101DetailModal.form.tel"
                    size="20"
                    maxlength="20"
                    disabled
                  />
                </td>
                <td>E-Mail</td>
                <td>
                  <input
                    type="text"
                    v-model="A101DetailModal.form.email"
                    size="20"
                    maxlength="40"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>到職日</td>
                <td>
                  <DatePicker
                    v-model="A101DetailModal.form.arriveDate"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                    disabled
                  />
                </td>
                <td>去職日</td>
                <td>
                  <DatePicker
                    v-model="A101DetailModal.form.leaveDate"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>現職狀況</td>
                <td colspan="3">
                  <select
                    v-model="A101DetailModal.form.leave"
                    style="min-width: 480px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .onJobs"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>應申報身分資格</td>
                <td colspan="3">
                  <select
                    v-model="A101DetailModal.form.status"
                    style="max-width: 1000px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in A101DetailModal.dropDownList
                        .OnDeclare"
                      :value="item.mcode"
                      :key="index"
                    >
                      {{ item.mvalue }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>備註</td>
                <td colspan="3">
                  <p>
                    <input
                      type="text"
                      v-model="A101DetailModal.form.leave_Reason"
                      size="80"
                      maxlength="80"
                      disabled
                    />
                    <br />
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </A101DetailModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div :key="index" style="margin-bottom: 10px">
          <p>{{ Alert.txt }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenuIndex, getMenu, logOut } from "@/config/util.js";
import {
  SearchGovCode,
  SearchGridOnJob,
  SearchGridOnDeclare,
  A101_DetailInit,
  F204_SearchGrid,
  F204_ReSearchGrid,
  F204_SearchGrid2,
  F204_Print,
} from "@/service/api.js";
export default {
  name: "F204",
  data: function () {
    return {
      pageData: {
        MenuIndex: 4,
        MenuName: "",
        PrgName: "F204",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      Order: "",
      Sort: "",
      form: {
        idn: "",
        name: "",
        syear: String(new Date().getFullYear() - 1911 - 1),
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        pagesize: 10,
        currentpage: 1,
      },
      dropDownList: {
        jobGovCode1s: [],
        jobGovCode2s: [],
        jobGovCode3s: [],
        jobGovCode4s: [],
        syears: [],
      },
      grid: {},
      DetailModal: {
        show: false,
        title: "N104財稅資料查詢(含所得及財產)-查調結果",
        PreData: {},
        grid: {},
        MenuIndex: 0,
      },
      A101DetailModal: {
        show: false,
        title: "A101申報人基本資料",
        form: {
          govCode1: "",
          govCode2: "",
          govCode3: "",
          govCode4: "",
          jobGovCode1: "",
          jobGovCode2: "",
          jobGovCode3: "",
          jobGovCode4: "",
          idn: "",
          name: "",
          birthday: "",
          title: "",
          rank: "",
          tel: "",
          email: "",
          arriveDate: "",
          leaveDate: "",
          //現職狀況
          leave: "",
          //應申報身分資格
          status: "",
          //備註
          leave_Reason: "",
        },
        modifyType: "", //"I,U"
        dropDownList: {
          govCode1s: [],
          govCode2s: [],
          govCode3s: [],
          govCode4s: [],
          jobGovCode1s: [],
          jobGovCode2s: [],
          jobGovCode3s: [],
          jobGovCode4s: [],
          OnDeclare: [],
          onJobs: [],
        },
        PreData: {},
      },
      Alert: {
        show: false,
        title: "",
        txt: "",
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    DetailModal: VueModal,
    A101DetailModal: VueModal,
    DatePicker: VueDatepicker,
    Alert: VueModal,
  },
  methods: {
    //取得受理申報機關第一層類別
    getSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別
    getSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    getSyearDropDownList: function () {
      let syears = [];
      const startYear = 99; //民國99年
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    //第一頁按紐查詢
    doQuery: function () {
      const self = this;
       //清空
      self.Order = "";
      self.Sort = "";
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        SYEAR: self.form.syear,
        GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        GOVCHECK: self.form.jobGovCheck,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      console.log(JSON.stringify(postData));
      F204_SearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "IDN";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        SYEAR: self.form.syear,
        GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        GOVCHECK: self.form.jobGovCheck,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      console.log(JSON.stringify(postData));
      F204_ReSearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //第一頁按紐重填
    btnClear: function () {
      const self = this;
      self.form = {
        idn: "",
        name: "",
        syear: "",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        pagesize: 10,
        currentpage: 1,
      };
      self.JobGovCodeInit(self.form);
      self.getSearchJobGovCode1();
    },
    JobGovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.jobGovCode1 = self.SessionGovCode;
        form.jobGovCode2 = "";
        form.jobGovCode3 = "";
        form.jobGovCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.jobGovCode1 = govCodeArray[0];
          form.jobGovCode2 = govCodeArray[1];
          form.jobGovCode3 = govCodeArray[2];
          form.jobGovCode4 = govCodeArray[3];
        }
      }
    },
    JobGovCode1Change: function () {
      const self = this;
      self.form.jobGovCode2 = "";
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode2s = [];
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode2Change: function () {
      const self = this;
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode3Change: function () {
      const self = this;
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode4s = [];
    },
    //第一頁按紐查看
    btnDetail: function (data) {
      const self = this;
      let postData = {
        idn: data.idn,
        syear: self.form.syear,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查看",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      console.log(JSON.stringify(postData));
      F204_SearchGrid2(postData).then((rData) => {
        if(rData.result){
          self.DetailModal.show = true;
          self.DetailModal.MenuIndex = 0;
          self.DetailModal.PreData = data;
          self.DetailModal.grid = rData.returnObject;
          //self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //第二頁按紐列印
    btnDetailModalPrint: function () {
      const self = this;
      let postData = {
        idn: self.DetailModal.PreData.idn,
        syear: self.form.syear,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "列印",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      F204_Print(postData).then((rData) => {
        console.log(rData);

        let link = document.createElement("a");
        link.download = "財稅資料 (含所得及財產)";
        link.href = "data:application/pdf;base64," + rData;
        link.click();
      });
    },
    //A101明細
    btnA101Detail: function (data) {
      const self = this;
      self.A101DetailModal.form = {
        //取得Radmin_Rel內
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        idn: "",
        name: "",
        birthday: "",
        title: "",
        rank: "",
        tel: "",
        email: "",
        arriveDate: "",
        leaveDate: "",
        //現職狀況
        leave: "",
        //應申報身分資格
        status: "",
        //備註
        leave_Reason: "",
      };
      self.A101DetailModal.PreData = data;
      self.getA101DetailData(data);

      self.A101DetailModal.modifyType = "U";
      self.A101DetailModal.title = "A101申報人基本資料維護-明細";
      self.A101DetailModal.show = true;
    },
    //A101明細 API
    getA101DetailData: function (data) {
      const self = this;
      A101_DetailInit({ idn: data.idn, goV_CODE: data.goV_CODE }).then(
        (rData) => {
          if (rData.result) {
            self.A101DetailModal.grid = rData.returnObject;
            self.A101DetailModal.form = {
              //取得Radmin_Rel內
              govCode1: self.A101DetailModal.grid.r_GovCodeStr.split(",")[0],
              govCode2: self.A101DetailModal.grid.r_GovCodeStr.split(",")[1],
              govCode3: self.A101DetailModal.grid.r_GovCodeStr.split(",")[2],
              govCode4: self.A101DetailModal.grid.r_GovCodeStr.split(",")[3],
              jobGovCode1:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[0],
              jobGovCode2:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[1],
              jobGovCode3:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[2],
              jobGovCode4:
                self.A101DetailModal.grid.jobGovCodeStr.split(",")[3],
              idn: self.A101DetailModal.grid.idn,
              name: self.A101DetailModal.grid.name,
              birthday: self.A101DetailModal.grid.birthday,
              title: self.A101DetailModal.grid.title,
              rank: self.A101DetailModal.grid.rank,
              tel: self.A101DetailModal.grid.tel,
              email: self.A101DetailModal.grid.email,
              arriveDate: self.A101DetailModal.grid.arriveDate,
              leaveDate: self.A101DetailModal.grid.leaveDate,
              //現職狀況
              leave: self.A101DetailModal.grid.leave,
              //應申報身分資格
              status: self.A101DetailModal.grid.status,
              //備註
              leave_Reason: self.A101DetailModal.grid.leaveReason,
            };
          } else {
            self.A101DetailModal.show = false;

            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = [
              "未取得資料，請至A101確認此[身分證統一編號][受理申報機關]是否有資料",
            ];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
            };
          }
          self.A101DetailModalInit();
        }
      );
    },
    A101DetailModalInit: function () {
      const self = this;
      self.modalGetA101SearchGovCode1();
      self.modalGetA101SearchGovCode2();
      self.modalGetA101SearchGovCode3();
      self.modalGetA101SearchGovCode4();
      self.modalGetA101OnDeclare();
      self.modalGetA101OnJob();
    },
    //A101明細取得服務機關第一層類別 DetailModal
    modalGetA101SearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.A101DetailModal.dropDownList.govCode1s = rData.returnObject;
        self.A101DetailModal.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //A101明細取得服務機關第二層類別 DetailModal
    modalGetA101SearchGovCode2: function () {
      const self = this;
      if (self.A101DetailModal.form.govCode1 != "") {
        let GovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.govCode1,
          LAYER_NUM: "2",
          GOV_CODE: "",
        };
        SearchGovCode(GovCode).then((rData) => {
          self.A101DetailModal.dropDownList.govCode2s = rData.returnObject;
          self.A101DetailModal.form.govCode2 =
            self.A101DetailModal.form.govCode2;
        });
      }
      if (self.A101DetailModal.form.jobGovCode1 != "") {
        let jobGovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.jobGovCode1,
          LAYER_NUM: "2",
          GOV_CODE: "",
        };
        SearchGovCode(jobGovCode).then((rData) => {
          self.A101DetailModal.dropDownList.jobGovCode2s = rData.returnObject;
          self.A101DetailModal.form.jobGovCode2 =
            self.A101DetailModal.form.jobGovCode2;
        });
      }
    },
    //A101明細取得服務機關第三層類別 DetailModal
    modalGetA101SearchGovCode3: function () {
      const self = this;
      if (self.A101DetailModal.form.govCode2 != "") {
        let GovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.govCode2,
          LAYER_NUM: "3",
          GOV_CODE: "",
        };
        SearchGovCode(GovCode).then((rData) => {
          self.A101DetailModal.dropDownList.govCode3s = rData.returnObject;
          self.A101DetailModal.form.govCode3 =
            self.A101DetailModal.form.govCode3;
        });
      }
      if (self.A101DetailModal.form.jobGovCode2 != "") {
        let jobGovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.jobGovCode2,
          LAYER_NUM: "3",
          GOV_CODE: "",
        };
        SearchGovCode(jobGovCode).then((rData) => {
          self.A101DetailModal.dropDownList.jobGovCode3s = rData.returnObject;
          self.A101DetailModal.form.jobGovCode3 =
            self.A101DetailModal.form.jobGovCode3;
        });
      }
    },
    //A101明細取得服務機關第四層類別 DetailModal
    modalGetA101SearchGovCode4: function () {
      const self = this;
      if (self.A101DetailModal.form.govCode3 != "") {
        let GovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.govCode3,
          LAYER_NUM: "4",
          GOV_CODE: "",
        };
        SearchGovCode(GovCode).then((rData) => {
          self.A101DetailModal.dropDownList.govCode4s = rData.returnObject;
          self.A101DetailModal.form.govCode4 =
            self.A101DetailModal.form.govCode4;
        });
      }
      if (self.A101DetailModal.form.jobGovCode3 != "") {
        let jobGovCode = {
          UP_GOV_CODE: self.A101DetailModal.form.jobGovCode3,
          LAYER_NUM: "4",
          GOV_CODE: "",
        };
        SearchGovCode(jobGovCode).then((rData) => {
          self.A101DetailModal.dropDownList.jobGovCode4s = rData.returnObject;
          self.A101DetailModal.form.jobGovCode4 =
            self.A101DetailModal.form.jobGovCode4;
        });
      }
    },
    //A101取得申報身分資格 DetailModal
    modalGetA101OnDeclare: function () {
      const self = this;
      SearchGridOnDeclare({}).then((rData) => {
        self.A101DetailModal.dropDownList.OnDeclare = [
          { mcode: "", mvalue: "" },
        ].concat(rData.returnObject);
      });
    },
    //A101取得在職狀態 GovCodeModal
    modalGetA101OnJob: function () {
      const self = this;
      SearchGridOnJob({}).then((rData) => {
        self.A101DetailModal.dropDownList.onJobs = [
          { value: "", text: "" },
        ].concat(rData.returnObject);
      });
    },
  },
  watch: {
    "form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode2(newValue);
    },
    "form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode3(newValue);
    },
    "form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode4(newValue);
    },
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
  },
  created() {
    const self = this;
    //教育部的部分新系統後台請維持先前作法，以系統寫死六組之方式
    if(self.loginInfo && self.loginInfo.govCodeStr.split(',')[0] === '309000000E'){
      switch(self.loginInfo.govCode)
      {
        case "309000000E":
        case "309000100E":
        case "A09000000E":
        case "A09010000E":
        case "A09020000E":
        case "309130000E":
        case "309190000E":
          break;
        default:
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = "無進入此頁權限，請洽詢管理員!!";
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.$router.go(-1);
          };
          break;
      }
    }
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = "無進入此頁權限，請洽詢管理員!!";
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.dropDownList.syears = self.getSyearDropDownList();
    self.JobGovCodeInit(self.form);
    self.getSearchJobGovCode1();
  },
};
</script>
<style>
.TabbedPanelsTab {
  position: relative;
  top: 1px;
  float: left;
  background-color: #eeeeee;
  list-style: none;
  cursor: pointer;
  padding-top: 10px;
  padding-right: 15px;
  padding-bottom: 10px;
  padding-left: 15px;
  font-family: sans-serif;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin: 0px;
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-top-style: solid;
  border-right-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-top-color: #ccc;
  border-right-color: #ccc;
  border-bottom-color: #ccc;
  border-left-color: #ccc;
}
</style>
<style scoped src="@/assets/css/Pdis.css" />

